import React, { useEffect, useState } from 'react';
import {
  InputFileLoadingContent,
  InputFileLoadingDocumentInfo,
  InputFileLoadingDocumentInfoContent,
  InputFileLoadingDocumentInfoText
} from './styles';
import { IoClose, IoDocumentTextOutline } from 'react-icons/io5';
import colors from '../../assets/styles/colors';

const InputFileLoaderPreviewItem = ({ item, removeFile, id }) => {
  const [showPreview, setShowPreview] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setShowPreview(true)
    }, 2000);
  }, [item])

  return (
    <InputFileLoadingContent key={id} id="file-preview">
      <InputFileLoadingDocumentInfo>
        <InputFileLoadingDocumentInfoContent>
          {showPreview ? <img src={URL.createObjectURL(item)} width="400" height="400"/> : <IoDocumentTextOutline color={colors.white} size={60} id="document-text-outline" />}
          <InputFileLoadingDocumentInfoText>{item.name}</InputFileLoadingDocumentInfoText>
          <InputFileLoadingDocumentInfoText>{(item.size / Math.pow(1024, 2)).toFixed(2)} mb</InputFileLoadingDocumentInfoText>
        </InputFileLoadingDocumentInfoContent>
      </InputFileLoadingDocumentInfo>
      <IoClose color={colors.white} size={22} onClick={() => removeFile(id)} id="close-icon" />
    </InputFileLoadingContent>
  )
}

export default InputFileLoaderPreviewItem
